<template>
  <div
    class="checkpoint-criteria-bar"
    :class="rootClass"
  >
    <span class="checkpoint-criteria-bar__text">{{ criteria_with_prefix }}</span>
  </div>
</template>

<script setup>
import { computed } from "vue";

const props = defineProps({
  criteria_with_prefix: {
    type: String,
    required: true,
  },
  level: {
    type: String,
    required: true,
    validator: (v) =>
      ["Apprentice", "Professional", "Coach", "Master"].includes(v),
  },
});

const rootClass = computed(() => ({
  [`checkpoint-criteria-bar--${props.level}`]: true,
}));
</script>

<style scoped>
.checkpoint-criteria-bar {
  display: flex;
  align-items: center;
  width: 100%;
  padding: 5px 10px;
  border-radius: 8px;
  border: 1px solid;
  box-sizing: border-box;
}

.checkpoint-criteria-bar__text {
  min-width: 0;
  flex: 1 1 auto;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-family: Inter, system-ui, -apple-system, "Segoe UI", Roboto, Arial, sans-serif;
  font-size: 12px;
  font-weight: 500;
  line-height: 20px;
  color: #101828;
}

/* Themes aligned with CheckpointLevelBand / ReadinessBadge proficiency chips */
.checkpoint-criteria-bar--Apprentice {
  background-color: #FFF5D3;
  border-color: #E58700;
}

.checkpoint-criteria-bar--Professional {
  background-color: #f3fff9;
  border-color: #00b813;
}

.checkpoint-criteria-bar--Coach {
  background-color: #effeff;
  border-color: #00a3ff;
}

.checkpoint-criteria-bar--Master {
  background-color: #f2f3ff;
  border-color: #2e1ec1;
}
</style>
